import { Grid, makeStyles } from "@material-ui/core";
import { Button, DateField, StandardDialog } from "@roc/ui";
import { observer } from "mobx-react";
import { ServicingTransfersStore } from "../../stores/servicingTransfersStore";

interface IMarkAsBoardedModalProps {
  servicingTransfersStore: ServicingTransfersStore;
  showMarkAsBoardedModal: boolean;
  closeBoardedModal: () => void;
  loanIds: number[];
}

const useStyles = makeStyles(theme => ({
  selectorFilter: {
    width: '180px',
    marginRight: '16px',
  },
}));

export const MarkAsBoardedModal = observer(({ servicingTransfersStore, loanIds, showMarkAsBoardedModal, closeBoardedModal }: IMarkAsBoardedModalProps) => {
  const classes = useStyles();

  const getContent = () => {
    return (
      <Grid container>
        <Grid item xs={12}>
          <DateField
            testId="date"
            inputVariant="outlined"
            format="MM/dd/yyyy"
            label="Date"
            value={servicingTransfersStore.boardingPackageSentDate}
            onChange={date => servicingTransfersStore.boardingPackageSentDate = date}
            maxDate={new Date()}
            className={classes.selectorFilter}
            required
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <StandardDialog
      open={showMarkAsBoardedModal}
      title={"Mark as Boarded"}
      maxWidth="xs"
      handleClose={closeBoardedModal}
      dialogContent={
        getContent()
      }
      dialogActions={(
        <>
          <Button
            style={{ marginRight: '8px' }}
            onClick={() => {
              closeBoardedModal();
            }}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if(servicingTransfersStore.boardingPackageSentDate) {
                closeBoardedModal();
                servicingTransfersStore.markBoardingPackageAsSent(loanIds, servicingTransfersStore.boardingPackageSentDate);
              } else {
                servicingTransfersStore.globalStore.notificationStore.showErrorNotification({
                  message: 'Please select a date to mark as boarded.'
                });
              }
            }}
            color="primary"
            variant="contained"
            testId="confirm"
          >
            Mark As Boarded
          </Button>
        </>
      )}
    />
  );

});
